import { Rooftop } from "../../rooftop";

export class getSelectedRofftop {
    rooftops:Array<Rooftop>;
    constructor(rooftops) {
        this.rooftops = rooftops;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/app/get-selected-rofftop.ts